import axios from "axios";

const postDataWithToken = async (
  url,
  data,
  admin_panel_user,
  logout,
  responseType
) => {
  try {
    let response = await axios({
      url: url,
      method: "post",
      data: data,
      headers: {
        Authorization: `Bearer ${admin_panel_user.token}`,
      },
      responseType: responseType ? responseType : "",
    });

    if (response.data.status === false && response.data.code === 401) {
      logout();
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return error.response;
    // if (error.response.status === 401) {
    //   logout();
    // } else {
    //   return error.response;
    // }
  }
};

export { postDataWithToken };
